import { render } from "./PdfViewer.vue?vue&type=template&id=1a61c8e7&scoped=true"
import script from "./PdfViewer.vue?vue&type=script&lang=js"
export * from "./PdfViewer.vue?vue&type=script&lang=js"

import "./PdfViewer.vue?vue&type=style&index=0&id=1a61c8e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a61c8e7"]])

export default __exports__